import { AxiosRequestConfig } from "axios";
import  engineeringServices from "../services/engineeringServices";
import { EngineeringRequest } from "../@types/engineeringTypes";

// * MAIN ACTIONS * \\


export async function fetchPaginatedEngineering(config: AxiosRequestConfig) {
    const response = await engineeringServices.getEngineering(config);
    return response;
};

export async function fetchEngineeringsTileKey(config: AxiosRequestConfig) {
    config.params = {
      ...config.params,
      tileKey: true
    };
    const response = await engineeringServices.getEngineeringsTileKey(config);
    return response;
};

export async function fetchEngineeringById(id: string) {
    const response = await engineeringServices.getEngineeringById(id);
    return response;
};

export async function deleteEngineeringById(id: string) {
    const response = await engineeringServices.deleteEngineeringById(id);
    return response;
};

export async function createEngineering(engineeringData: EngineeringRequest) {
    const response = await engineeringServices.createEngineering(engineeringData);
    return response;
};

export async function updateEngineering(id: string, updatedEngineeringData: EngineeringRequest) {
    const response = await engineeringServices.updateEngineering(id, updatedEngineeringData);
    return response;
};

// * MAP ACTIONS * \\

export async function fetchEngMapInformationChart(config: AxiosRequestConfig) {
    const response = await engineeringServices.getEngMapInformationChart(config);
    return response;
};

export async function fetchEngMapInformationPointLine(config: AxiosRequestConfig) {
    const response = await engineeringServices.getEngMapInformationPointLine(config);
    return response;
};


// * URLS PARA GRAFICOS * \\
export const engGraphics = {
    engenhariaTipo: 'eng_records/engenharia_tipo',
    engenhariaMes: 'eng_records/engenharia_mes',
};